import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { currentId: String }
  static targets = ["treeItem", "detailsFrame"]

  connect() {
    // Listen for turbo frame loads to update active state
    document.addEventListener('turbo:frame-load', this.handleFrameLoad.bind(this))
    console.log(this.currentIdValue)
    // Set initial active state based on currentId
    if (this.hasCurrentIdValue) {
      this.updateActiveState(this.currentIdValue)
    }
  }

  disconnect() {
    document.removeEventListener('turbo:frame-load', this.handleFrameLoad.bind(this))
  }

  selectClassification(event) {
    // Get classification ID from the clicked element
    const treeItem = event.currentTarget.closest('[data-classification-id]')
    if (!treeItem) return

    const classificationId = treeItem.dataset.classificationId

    // Update active state
    this.updateActiveState(classificationId)
  }

  updateActiveState(activeId) {
    // Remove active state from all items
    this.treeItemTargets.forEach(item => {
      item.classList.remove('active')
      item.dataset.active = 'false'
    })

    // Add active state to selected item
    const activeItem = this.treeItemTargets.find(item =>
      item.dataset.classificationId === activeId
    )

    if (activeItem) {
      activeItem.classList.add('active')
      activeItem.dataset.active = 'true'
    }
  }

  handleFrameLoad(event) {
    // Update active state when frame loads (handles browser back/forward)
    if (event.target.id === 'classification-details') {
      // Try to extract classification ID from the URL
      const response = event.detail?.fetchResponse?.response
      if (response) {
        const url = new URL(response.url)
        const pathParts = url.pathname.split('/')
        const classificationId = pathParts[pathParts.length - 1]
        this.updateActiveState(classificationId)
      }
    }
  }
}
